import { render, staticRenderFns } from "./OrdersStatsTimeline.component.vue?vue&type=template&id=deb10826&scoped=true&"
import script from "./OrdersStatsTimeline.component.vue?vue&type=script&lang=js&"
export * from "./OrdersStatsTimeline.component.vue?vue&type=script&lang=js&"
import style0 from "./OrdersStatsTimeline.component.vue?vue&type=style&index=0&id=deb10826&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb10826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VSkeletonLoader,VSpacer,VSubheader,VTimeline,VTimelineItem,VTooltip})
